import { getLocale } from "../runtime";

const sv_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hämtar spårningsinformation...`
};

const trackorderloading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackorderloading(inputs)
	return "trackOrderLoading";
};

export { trackorderloading as "trackOrderLoading" };